import {AfterViewInit, Component, ElementRef, forwardRef, inject, NgZone, PLATFORM_ID, ViewChild} from '@angular/core';
import {IconLocationComponent} from '../icons/icon-location/icon-location.component';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'braidsbook-address-search',
  imports: [IconLocationComponent],
  templateUrl: './address-search.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressSearchComponent),
      multi: true
    }
  ]
})
export class AddressSearchComponent implements AfterViewInit, ControlValueAccessor {
  readonly #ngZone: NgZone = inject(NgZone);
  readonly #platformId = inject(PLATFORM_ID);

  @ViewChild('search', {static: true}) searchInput!: ElementRef<HTMLInputElement>;
  searchTerm: string = '';

  onChange: (value: string) => void = () => {
  };
  onTouched: () => void = () => {
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    this.searchTerm = value || '';
    if (this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.value = this.searchTerm;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.disabled = isDisabled;
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.#platformId)) {
      const autocomplete = new google.maps.places.Autocomplete(this.searchInput.nativeElement, {
        types: ['geocode'], componentRestrictions: {country: 'CA'}, fields: ['formatted_address']
      });
      autocomplete.addListener('place_changed', () => {
        this.#ngZone.run(() => {
          const place = autocomplete.getPlace();
          this.searchTerm = place.formatted_address || '';
          this.onChange(this.searchTerm);
          this.onTouched();
        });
      });
    }
  }

}
